import { useQuery } from '@tanstack/react-query';
import { productsApi } from '@/lib/api';

export const useProductCategories = () => {
  return useQuery({
    queryKey: ['productCategories'],
    queryFn: async () => {
      const { data } = await productsApi.getCategories();
      return data;
    },
  });
};

export const useIssueCategories = (categoryId) => {
  return useQuery({
    queryKey: ['issueCategories', categoryId],
    queryFn: async () => {
      const { data } = await productsApi.getIssues(categoryId);
      return data;
    },
    enabled: !!categoryId,
  });
};

export const useMyProducts = () => {
  return useQuery({
    queryKey: ['myProducts'],
    queryFn: async () => {
      const { data } = await productsApi.getMy();
      return data;
    },
  });
};